export enum ACCESSORY_CLICK {
    LEARN_MORE = 'accessoryLearnMoreClicked',
    CLOSE_POPUP = 'accessoryClosePopupClicked',
}

export const enum ACCESSORIES_TABS {
    ESSENTIALS = 'Essentials',
    CHAINS = 'Chains',
    CASES = 'Cases',
    WIPES = 'Wipes',
}
